import {
  APIResponseCollectionPagination,
  APIOffsetBasedPagination,
} from "@superagents/types/api";

export const PAGINATION = {
  defaultLimit: 25,
  maxLimit: 100,
  defaultWithCount: true,
  defaultOffset: 0,
};

export const getNextOffset = (
  currentStart: number,
  currentLimit: number,
  totalEntries: number
) => {
  const hasNextPage = currentStart + currentLimit < totalEntries;

  return hasNextPage ? currentStart + currentLimit : undefined;
};

const isOffsetBasedPagination = (
  pagination: APIResponseCollectionPagination
): pagination is APIOffsetBasedPagination => {
  return "start" in pagination && "limit" in pagination;
};

export const getPaginationParams = (
  pagination: APIResponseCollectionPagination
) => {
  if (isOffsetBasedPagination(pagination)) {
    return {
      start: pagination.start ?? PAGINATION.defaultOffset,
      limit: pagination.limit ?? PAGINATION.defaultLimit,
      total: pagination.total ?? 0,
    };
  }

  const page = pagination.page ?? 0;
  const pageSize = pagination.pageSize ?? PAGINATION.defaultLimit;

  return {
    start: page * pageSize,
    limit: pageSize,
    total: pagination.total ?? 0,
  };
};
